enum ConfigurationReference {
    ActiveSeason = 'ACTIVE_SEASON',
    SalesCampaign = 'SALES_CAMPAIGN',
    Insurance = 'INSURANCE',
    EngineeringInsurancePercentage = 'ENGINEERING_INSURANCE_PERCENTAGE',
    EngineeringInsuranceActivatedByDefault = 'ENGINEERING_INSURANCE_ACTIVATED_BY_DEFAULT' // A=active, outher=disabled
}

export default ConfigurationReference;
